<template>
  <div>
    <Distrikts v-show="$store.step == 0" />
    <Cards v-if="$store.step == 1" />
    <Form v-if="$store.step == 2" />
    <!-- <div v-for="(item, index) in blockMap" :key="index">
      {{ item.value.properties }}
    </div>
    <NotionRenderer :blockMap="blockMap" fullPage /> -->
  </div>
</template>

<script>
import Cards from "./Cards.vue";
import Distrikts from "./Distrikts.vue";
import Form from "./Form.vue";
// import { NotionRenderer, getPageBlocks } from "vue-notion";

export default {
  name: "Start",
  components: {
    Cards,
    Distrikts,
    Form,
    // NotionRenderer,
  },
  data: () => ({ blockMap: null }),
  async created() {
    // get Notion blocks from the API via a Notion pageId
    // this.blockMap = await getPageBlocks("dd2d84a5598345e6b88fff093647550e");
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  padding: 0;
  margin: 0;
}
.button {
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
}
</style>
